<template>
  <card type="secondary"
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0 mb-0">
    <div class="card-header">
      <h5 class="title welcome-text">Add clocks manually</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12 ml-auto mr-auto">
            <div class="row">
              <div class="col-lg-12">
                <my-data-picker :date="dates" label="Pick the date"></my-data-picker>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <base-input label="Time of beginning">
                  <select v-model="dates.time.start"  class="form-control">
                    <option v-for="(item, index) in selectTimes" :key="index">{{timeToAmPm(item)}}</option>
                  </select>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <base-input label="Time of ending">
                  <select v-model="dates.time.end"  class="form-control">
                    <option v-for="(item, index) in selectTimes" :key="index">{{timeToAmPm(item)}}</option>
                  </select>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-lg-8 ml-auto mr-auto">
          <base-button class="animation-on-hover" block type="warning" @click="add">Save</base-button>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
    import MyDataPicker from "../../components/DataPicker";
    export default {
      components: {MyDataPicker},
      props: ['dates'],
      name: "add-clock-panel",
      data(){
        return{
          selectTimes:[],
        }
      },
      methods:{
        add(){
          this.$emit('add-clock')
        },
        timeToAmPm:function(time){
          let timeValue = 0;
          if (time !== null){
            time = time.split(':');
            if (time.length === 2){
              let hours = Number(time[0]);
              let minutes = Number(time[1]);

              if (hours > 0 && hours <= 12) {
                timeValue = hours;
              } else if (hours > 12) {
                timeValue = hours - 12;
              } else if (hours === 0) {
                timeValue = 12;
              }
              timeValue = (timeValue < 10) ? "0" + timeValue: timeValue;
              timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
              //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
              timeValue += (hours >= 12) ? " pm" : " am";  // get AM/PM
            }
          }
          return timeValue || time;
        },
      },
      created() {
        for (let i = 0; i<24; i++){
          this.selectTimes.push(((i<10)?'0'+i:i)+':00');
          this.selectTimes.push(((i<10)?'0'+i:i)+':30');
        }

      },
    }
</script>

<style scoped>
</style>
